import { render, staticRenderFns } from "./ImportTemplate.vue?vue&type=template&id=3c43dae7&scoped=true"
import script from "./ImportTemplate.vue?vue&type=script&lang=js"
export * from "./ImportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c43dae7",
  null
  
)

export default component.exports